import React from 'react';
import { makeStyles } from 'tss-react/mui';
import MuiSwipeableDrawer from '@mui/material/SwipeableDrawer';

export type SwipeableDrawerProps =
  import('@mui/material/SwipeableDrawer').SwipeableDrawerProps;

const useStyles = makeStyles()(() => ({
  fullWidth: {
    width: '100%',
  },
}));

interface CustomProps {
  fullWidth?: boolean;
}

const SwipeableDrawer = React.forwardRef<
  HTMLDivElement,
  CustomProps & SwipeableDrawerProps
>(({ fullWidth, classes, ...rest }, ref) => {
  const { classes: customClasses, cx } = useStyles();

  return (
    <MuiSwipeableDrawer
      {...rest}
      ref={ref}
      classes={
        fullWidth
          ? {
              ...classes,
              paper: cx(classes?.paper, customClasses.fullWidth),
            }
          : classes
      }
    />
  );
});

export { SwipeableDrawer };
